import React from 'react'
import styled, { css } from 'styled-components'

/**
 * {step} 0: 미완료, 1: 완료, 2: 진행중
 */
const StatusBadge = ({ step }) => {
    const statusInfo = {
        0: {
            text: "미완료",
            color: "var(--gray-color)",
            bg: "var(--bg-dark)",
        },
        1: {
            text: "완료",
            color: "var(--main-point-color)",
            bg: "var(--bg-blue)",
        },
        2: {
            text: "진행중",
            color: "var(--green-dark)",
            bg: "var(--bg-green)",  
        },
    }

    if (!statusInfo[step]) return null

    const currentStatus = statusInfo[step]

    return (
        <BadgeContainer style={{ background: currentStatus.bg }}>
            <BadgeDot style={{ background: currentStatus.color }} />
            <BadgeText style={{ color: currentStatus.color }}>
                {currentStatus.text}
            </BadgeText>
        </BadgeContainer>
    )
}

const BadgeContainer = styled.div`
    display: inline-flex;
    justify-content: center;
    align-items: center;
    gap: 6px;
    padding: 6px 10px;
    border-radius: 15px;
`

const BadgeDot = styled.div`
    width: 8px;
    height: 8px;
    border-radius: 50%;
`

const BadgeText = styled.div`
    font-size: 15px;
    font-weight: 600;
    line-height: 1em;
`

export default StatusBadge